import React from 'react';
import {
  Container,
  ColorDropdownMenu,
  ColorDropdownContainer,
  SelectedColorContainer,
  ColorOptionContainer,
  CircleOptionContainer,
  ColoredCircle,
  CircleBorder,
  Arrow,
} from './style';
import { uniq } from 'lodash';

export interface ColorDropdownProps {
  selected: string;
  options: string[];
  onChange?: (color: string) => void;
}

const defaultProps = {};

function ColorDropdown({ selected, options, onChange }: ColorDropdownProps) {
  const [isDropdownVisible, setDropdownVisible] = React.useState<boolean>(
    false,
  );
  const [selectedColor, setSelectedColor] = React.useState<string>(selected);

  React.useEffect(() => {
    return () => setDropdownVisible(false);
  }, []);

  function toggleDropdown() {
    setDropdownVisible(!isDropdownVisible);
  }

  function selectColor(color: string): Function {
    return function () {
      setSelectedColor(color);
      setDropdownVisible(false);
      onChange && onChange(color);
    };
  }

  return (
    <Container>
      <SelectedColorContainer onClick={toggleDropdown}>
        <ColorOption color={selectedColor} />
        <Arrow $menuOpened={isDropdownVisible} />
      </SelectedColorContainer>
      {isDropdownVisible && (
        <ColorDropdownContainer>
          <ColorDropdownMenu>
            {uniq(options).map((color) => (
              <ColorOptionContainer key={color} onClick={selectColor(color)}>
                <ColorOption color={color} />
              </ColorOptionContainer>
            ))}
          </ColorDropdownMenu>
        </ColorDropdownContainer>
      )}
    </Container>
  );
}

function ColorOption({ color }) {
  const colorBorder = '#000';
  return (
    <CircleOptionContainer>
      <CircleBorder color={colorBorder} />
      <ColoredCircle color={color} />
    </CircleOptionContainer>
  );
}

ColorDropdown.defaultProps = defaultProps;

export default ColorDropdown;
